import * as React from 'react';
import './YouTravelPageContainer.scss';
import { parse } from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
const background = require('./images/cover-image2x.jpg');

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

export function mapProps() {
    return;
}

export function mapDispatch() {
    return;
}

interface YouTravelPageContainerState {
    service: string;
}

export class YouTravelPageContainer extends React.Component<RouteProps, YouTravelPageContainerState> {
    state = {
        service: ''
    };

    componentDidMount() {
        const {history} = this.props;
        document.title = 'YouTravel.me';
        if (history.location.search) {
            const params = parse(history.location.search);
            if (params.service) {
                this.setState({service: params.service});
            }
        }
    }

    componentDidUpdate(prevProps: Readonly<RouteProps>, prevState: Readonly<YouTravelPageContainerState>, snapshot?: any) {
        const {history} = this.props;
        const {service} = this.state;
        if (history.location.search) {
            const params = parse(history.location.search);
            if (params.service && params.service !== service) {
                this.setState({service: params.service});
            }
        }
    }

    render() {
        const {history} = this.props;
        const {service} = this.state;
        return (
            <div className={`you_travel_container ${service}`}>
                <img
                    src={background}
                    alt='Изображение горы'
                />
                <div className='grid'>
                    <div>
                        <h1>
                            Новый формат необычных путешествий в уникальные места:
                        </h1>
                        <p>
                            Нестандартные маршруты от проверенных авторов путешествий
                        </p>
                    </div>
                    <p>
                        Путешествие небольшой компанией близких по духу единомышленников
                    </p>
                    <p>
                        Никаких забот - проживание, питание и активности за тебя уже продумал автор путешествия
                    </p>
                    <div>
                        <p>
                            Для получения 5% скидки используйте промокод КОНСЬЕРЖ при оплате тура (поле «У меня есть промокод»)
                        </p>
                        <button
                            onClick={() => history.push('/you_travel/search')}
                        >
                            Забронировать
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/YouTravel/YouTravelPageContainer.tsx